import { useEffect, useRef } from 'react';
import { db } from '@/db/db';
import { saveRow } from '@/data/repo';

const IDLE_AFTER_MS = 5 * 60_000;
const EVENTS = ['pointermove', 'pointerdown', 'keydown', 'wheel'] as const;

/**
 * While a Track run is live, record stretches with no input on this device into `active_timer.idleSegments`
 * so the stop card can offer "Split at idle" (8f). A stretch is recorded when it ends (input returns).
 */
export function useIdleTracker(active: boolean) {
  const lastInput = useRef(0);
  const idleSince = useRef<number | null>(null);
  useEffect(() => {
    if (!active) return;
    lastInput.current = Date.now();
    idleSince.current = null;
    const check = async () => {
      const now = Date.now();
      if (idleSince.current == null && now - lastInput.current >= IDLE_AFTER_MS) idleSince.current = lastInput.current;
    };
    const onInput = async () => {
      const now = Date.now();
      if (idleSince.current != null) {
        const seg: [string, string] = [new Date(idleSince.current).toISOString(), new Date(now).toISOString()];
        idleSince.current = null;
        const t = await db.activeTimer.get('active');
        if (t?.status === 'running') await saveRow('activeTimer', { ...t, idleSegments: [...t.idleSegments, seg] });
      }
      lastInput.current = now;
    };
    const id = setInterval(check, 30_000);
    for (const e of EVENTS) window.addEventListener(e, onInput, { passive: true });
    return () => { clearInterval(id); for (const e of EVENTS) window.removeEventListener(e, onInput); };
  }, [active]);
}
